import { render, staticRenderFns } from "./stripe-form.vue?vue&type=template&id=36c9aebb&scoped=true"
import script from "./stripe-form.vue?vue&type=script&lang=js"
export * from "./stripe-form.vue?vue&type=script&lang=js"
import style0 from "./stripe-form.vue?vue&type=style&index=0&id=36c9aebb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9aebb",
  null
  
)

export default component.exports